export { default as WireframeOutlineIcon } from './WireframeOutlineIcon';
